import React from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";

export const NO_CONFIRM = { open: false, title: "", message: "", confirmLabel: "", onConfirm: null };

/**
 * The batch editor's prompt. `tone: "error"` (default) for a choice that loses
 * work, `"primary"` for an offer or a save. An optional middle action
 * (`altLabel` / `onAlt`) makes it a three-way choice, and `list` (strings)
 * names what the message is about, one per line. Cancel runs nothing.
 */
export default function BatchConfirmDialog({ confirm, onClose }) {
  const { open, title, message, confirmLabel, cancelLabel = "Keep editing", tone = "error", onConfirm, altLabel, onAlt, list } = confirm;
  const run = (action) => () => {
    onClose();
    if (action) action();
  };
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 700 }}>{title}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary">
          {message}
        </Typography>
        {list?.length > 0 && (
          <Box component="ul" data-testid="batch-confirm-list" sx={{ m: 0, mt: 1.5, pl: 2.5, maxHeight: 240, overflowY: "auto" }}>
            {list.map((line) => (
              <Typography key={line} component="li" variant="body2" fontWeight={600} sx={{ py: 0.25 }}>
                {line}
              </Typography>
            ))}
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 0.5 }}>
        <Button onClick={onClose} sx={{ textTransform: "none", fontWeight: 600, mr: "auto" }}>
          {cancelLabel}
        </Button>
        {altLabel && (
          <Button onClick={run(onAlt)} color="error" variant="outlined" sx={{ textTransform: "none", fontWeight: 600 }}>
            {altLabel}
          </Button>
        )}
        <Button onClick={run(onConfirm)} color={tone} variant="contained" autoFocus={Boolean(altLabel)} sx={{ textTransform: "none", fontWeight: 700 }}>
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
